import { render } from "./product-history-tab.vue?vue&type=template&id=15511652&scoped=true"
import script from "./product-history-tab.vue?vue&type=script&lang=js"
export * from "./product-history-tab.vue?vue&type=script&lang=js"

import "./product-history-tab.vue?vue&type=style&index=0&id=15511652&scoped=true&lang=css"

import exportComponent from "/home/gerind/Desktop/work/gobe-system/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15511652"]])

export default __exports__